import PanelCard from 'components/card/PanelCard';
import { formatBonusValue } from 'helper/bonusValue';
import { restaurantTicketLines } from 'helper/remunerationConditions';
import RemunerationConditionsCard from './RemunerationConditionsCard';

/**
 * The company's remuneration terms, read-only (JBWEB-1208).
 *
 * The contract preview shows what the contract was drawn from, so nothing here
 * opens an editor: the panel shows one modal at a time, and a pencil that
 * could not open anything would be worse than no pencil.
 *
 * Same cards as the company panel — PanelCard, folded from the same control —
 * and same sentences, from helper/remunerationConditions: the same settings
 * described twice in two wordings would drift.
 */
const RemunerationSummary = ({ companyInfo }) => {
  const bonuses = companyInfo?.bonusesAndAllowances?.bonuses ?? [];
  const ticketLines = restaurantTicketLines(companyInfo);

  return (
    <div className={'flex flex-col gap-3'}>
      <RemunerationConditionsCard companyInfo={companyInfo} />

      <PanelCard
        title={'Ticket restaurant'}
        collapsible
        contentClassName={'py-3 px-4 text-gray-500'}
      >
        {ticketLines.length > 0 ? (
          ticketLines.map((line, index) => <div key={index}>{line}</div>)
        ) : (
          'Aucun ticket restaurant.'
        )}
      </PanelCard>

      {/* Open like the other two: this modal is read to check a contract
          against the terms it was drawn from, and a folded card hides part of
          the answer. */}
      <PanelCard
        title={'Primes & indemnités'}
        collapsible
        contentClassName={'divide-y'}
      >
        {bonuses.length === 0 ? (
          <div className={'py-3 px-4 text-gray-500'}>
            Aucune prime ni indemnité.
          </div>
        ) : (
          bonuses.map((bonus, index) => (
            <div
              key={bonus._id ?? index}
              className={'py-3 px-4 flex justify-between gap-2'}
            >
              <span className={'text-gray-900 min-w-0 truncate'}>
                {bonus.name?.name?.trim() ?? bonus.name ?? '—'}
              </span>
              <span className={'text-gray-500 shrink-0'}>
                {[bonus.unit?.name ?? bonus.unit, formatBonusValue(bonus, null)]
                  .filter(Boolean)
                  .join(' · ')}
              </span>
            </div>
          ))
        )}
      </PanelCard>
    </div>
  );
};

export default RemunerationSummary;
